import React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '~/utils/cn'
import Typography from '../Typography'

export type LabelTextProps = {
  isRequired?: boolean
  children: React.ReactNode
  isError?: boolean
}

const LabelText = ({
  isRequired = false,
  children,
  isError = false
}: LabelTextProps) => {
  const { t } = useTranslation()

  return (
    <span
      className={cn('text-left font-body text-label', {
        '!text-error': isError
      })}
    >
      {children}{' '}
      {!isRequired ? (
        <Typography
          variant="subtitle2"
          aria-hidden="true"
          className="inline text-black/25"
        >
          ({t('common:optional')})
        </Typography>
      ) : null}
    </span>
  )
}

export default LabelText
